import { useMutation } from "@apollo/client";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { useFormik } from "formik";
import { CREATE_PRODUCT } from "../../../../graphql/mutations";
import SelectDynamicFormId from "../../../../components/SelectDynamicFormId";

export default function CreateDialog({ open, handleClose, onCreate }) {

    // Setting mutation
    const [createProduct, { loading }] = useMutation(CREATE_PRODUCT);

    // Setting Formik
    const { handleSubmit, handleChange, setFieldValue, values, errors, resetForm } = useFormik({

        initialValues: { name: "", formId: null },

        onSubmit: (values) => {

            // Chamando a mutation de criação
            createProduct({
                variables: {
                    name: values.name,
                    dynamic_form_id: values.formId
                }
            }).then(() => {
                resetForm();
                onCreate();
            })

        }
    });

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll="paper"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle id="scroll-dialog-title">Criar novo Produto</DialogTitle>

                <DialogContent>

                    <TextField
                        variant="outlined"
                        margin="normal"
                        onChange={(e) => setFieldValue('name', e.target.value)}
                        value={values.name}
                        required
                        fullWidth
                        id="name"
                        label="Nome"
                        name="name"
                        autoFocus
                        error={errors.name && true}
                        helperText={errors.name}
                        style={{marginBottom: 16}}
                    />

                    <SelectDynamicFormId
                        value={values.formId}
                        inputName="formId"
                        onChange={(id) => setFieldValue("formId", id)}
                    />

                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSubmit} variant="contained" color="primary" disabled={values.name == "" || loading}>
                        {loading && <CircularProgress size={14} style={{ marginRight: 12 }} />}
                        Criar Produto
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
